import { Box, TextInput } from 'grommet';
import React, {useState} from 'react';
import {
    faClone as IconCopy
} from '@fortawesome/pro-light-svg-icons';
import {faLinkSimple as IconLink} from '@fortawesome/pro-regular-svg-icons'
import FontAwesomeIcon from './FontAwesomeIcon';
import Button from './Button';

const CopyLinkWidget = ({
    link,
    containerProps,
    copyLabel,
    icon,
    textProps
}) => {
    const [isClicked, setIsClicked] = useState(false);

    const copyLink = async () => {
        await navigator.clipboard.writeText(link);
        setIsClicked(true);
        setTimeout(() => {
            setIsClicked(false); // reset tooltip text
        }, 1000);
    };

    return (
        <Box
            background="background"
            wrap
            fill="horizontal"
            gap="xsmall"
            direction="row"
            responsive={false}
            border
            justify="between"
            align='center'
            round="xsmall"
            pad={{horizontal: 'xxsmall'}}
            {...containerProps}>
            <Box direction="row" flex margin={{left: 'xsmall'}} align="center">
                <FontAwesomeIcon SelectedIcon={icon || IconLink} size="small" color="text-xweak" />
                <TextInput size="small" value={link} plain {...textProps}/>
            </Box>
            <Box border={{side: "left"}} pad={{left: 'none', right: 'none'}}>
                <Button
                    event={{section: 'copy_link_widget', element: 'copy', description: link}}
                    tip={isClicked ? "Copied!" : "Copy link"}
                    hoverIndicator
                    onClick={copyLink}
                    plain
                    label={copyLabel ? copyLabel : 
                        (<Box pad={{vertical: 'xsmall', horizontal: 'xsmall'}}>
                            <FontAwesomeIcon SelectedIcon={IconCopy} size="xsmall" color="text-weak" />
                        </Box>)
                    } />
            </Box>
        </Box>
    );
}

export default CopyLinkWidget;